import { Component } from 'react';

// Catches render/runtime crashes so a participant never sees a blank page. The
// survey autosaves, so reloading resumes where they left off.
export class ErrorBoundary extends Component {
  constructor(props) { super(props); this.state = { error: null }; }
  static getDerivedStateFromError(error) { return { error }; }
  componentDidCatch(error, info) { console.error('App crash:', error, info); }
  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div style={{ maxWidth: 520, margin: '64px auto', padding: '0 20px', textAlign: 'center',
        fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Arial, sans-serif', color: '#1c2430' }}>
        <div style={{ fontSize: 44 }} aria-hidden="true">⚠️</div>
        <h1 style={{ fontSize: 22 }}>Something went wrong</h1>
        <p style={{ color: '#6b7686', lineHeight: 1.55 }}>
          Sorry — the page hit an unexpected error. Your progress is saved automatically, so reloading
          should pick up where you left off. If it keeps happening, try a different browser.
        </p>
        <button onClick={() => window.location.reload()} style={{ border: 0, borderRadius: 10, padding: '12px 22px',
          fontSize: 16, fontWeight: 600, background: '#1f4e79', color: '#fff', cursor: 'pointer' }}>Reload</button>
      </div>
    );
  }
}
